/*
 * サブシステム名：経営管理
 * 機能名：荷主別請求金額管理
 */

import DdDefaultButton from '@/components/DdDefaultButton'
import DdIconButton from '@/components/DdIconButton'
import DdCodeTextBox from '@/components/DdCodeTextBox'
import DdDateBox from '@/components/DdDateBox'
import DdTextBox from '@/components/DdTextBox'
import DdNumericBox from '@/components/DdNumericBox'
import DdSubHeader from '@/components/DdSubHeader'
import DdFooterButton from '@/components/DdFooterButton'
import DdDataTable from '@/components/DdDataTable'
import DdEditDialog from '@/components/DdEditDialog'
import DdRadioButton from '@/components/DdRadioButton'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox.vue'
import DdRowCountBox from '@/components/DdRowCountBox.vue'
import flowMixin from '@/mixins/flowMixins'
import header from '@/ddv2.library/header'
import tax from '@/ddv2.library/tax'
import validators from '@/rahmen/validators'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'

const DEFAULT_HEADER_NAME1 = '請求項目１（課税）'
const DEFAULT_HEADER_NAME2 = '請求項目２（課税）'
const DEFAULT_HEADER_NAME3 = '請求項目３（課税）'
const DEFAULT_HEADER_NAME4 = '請求項目１（非課税）'
const DEFAULT_HEADER_NAME5 = '請求項目２（非課税）'
const DEFAULT_HEADER_NAME6 = '請求項目３（非課税）'

export default {
  name: 'NinushibetsuSeikyuKingakuKanri',
  mixins: [flowMixin],
  data: () => ({
    kamotsuHeaders: [],
    nippoHeaders: [],
    expansionPanel: [0, 1],
    id: 1,
    // 権限
    modeKengen: 0,
    modeOfEdit: 0,
    conditions: {
      seikyuStartYmdString: '',
      seikyuEndYmdString: '',
      torihikisakiCd: '',
      eigyoshoCd: '',
      chakuchiCd: '',
      jomuinCd: '',
      yoshasakiCd: '',
      uriageSbt: '9'
    },
    EditMode: false,
    editButtonDisplay: false,
    initializeFlg: true,
    ninushiShitei: false,
    shiyoFlgCount: 6,
    seikyu1Nm: DEFAULT_HEADER_NAME1,
    seikyu2Nm: DEFAULT_HEADER_NAME2,
    seikyu3Nm: DEFAULT_HEADER_NAME3,
    seikyu4Nm: DEFAULT_HEADER_NAME4,
    seikyu5Nm: DEFAULT_HEADER_NAME5,
    seikyu6Nm: DEFAULT_HEADER_NAME6,
    seikyu1ShiyoFlg: true,
    seikyu2ShiyoFlg: true,
    seikyu3ShiyoFlg: true,
    seikyu4ShiyoFlg: true,
    seikyu5ShiyoFlg: true,
    seikyu6ShiyoFlg: true,
    seikyuKingaku: 0,
    calcUriageKingaku: 0,
    summarySeikyuUnchin: 0,
    summaryTsukoryo: 0,
    summaryZeinuki: 0,
    summarySeikyu1: 0,
    summarySeikyu2: 0,
    summarySeikyu3: 0,
    summarySeikyu4: 0,
    summarySeikyu5: 0,
    summarySeikyu6: 0,
    summaryAll: 0,
    summaryUriageKingaku: 0,
    hinmokuCount: 0,
    isCalcCheck: true,
    ninushiEditMode: false,
    searchText: '',
    // 表示用
    selectedItemKamotsu: [],
    selectedItemNippo: [],
    // チェックボックス制御
    selectedItemKamotsuCheck: [],
    selectedItemNippoCheck: [],
    kamotsu_expanded: [],
    nippo_expanded: [],
    customFooterProps: { 'items-per-page-options': [1000000] },
    // ヘッダリスト
    headersTorihikisakiList: header.mstTorihikisakiHeaders,
    headersSeikyusakiList: header.mstTorihikisakiHeaders,
    headersEigyoshoList: header.mstEigyoshoHeaders,
    headersHacchakuchiList: header.mstHacchakuchiHeaders,
    headersJininList: header.mstJininHeaders,
    page: 1,
    isCsvDownloader: false
  }),
  components: {
    DdSubHeader,
    DdDefaultButton,
    DdIconButton,
    DdCodeTextBox,
    DdDateBox,
    DdTextBox,
    DdNumericBox,
    DdRadioButton,
    DdNarrowDownTextBox,
    DdRowCountBox,
    DdEditDialog,
    DdFooterButton,
    DdDataTable
  },
  computed: {
    ...mapGetters({
      eigyoshoList: 'DDMasters/mstEigyosho',
      usersEigyoshoCd: 'users/eigyoshoCd',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      eigyoshoJininList: 'DDMasters/vwCMstEigyoshoJininList'
    }),
    // 取引先
    filteredTorihikisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    // 荷主
    filteredNinushiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.tokuisakiFlg === true
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    // 傭車先
    filteredYoshaList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.hacchusakiFlg === true
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    // 営業所
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.eigyoshoCd > elem2.eigyoshoCd) { return 1 }
        if (elem1.eigyoshoCd === elem2.eigyoshoCd) { return 0 }
        return -1
      })
    },
    // 着地
    filterdMstHacchakuchiList () {
      const target = filter.dateFormatter(new Date())
      return this.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    // 乗務員
    filterdMstJininList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoJininList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.jomuFlg === true && elem.eigyoshoKbn !== '03'
      })
    },
    // 検索結果
    rowCountCustom () {
      var cnt = 0
      if (Object.keys(this.rows).length === 0) {
      } else {
        if (this.rows.length !== 0 && this.rows.kamotsu !== null) {
          cnt = this.rows.kamotsu.length
        }
      }
      return cnt
    },
    // 絞り込み結果
    filteredRowCountCustom () {
      var cnt = 0
      if (!Object.keys(this.rows) && Object.keys(this.rows).length === 0) {
      } else {
        // 請求先指定：受注基本情報
        if (Object.keys(this.rows).length !== 0 && this.rows.length !== 0 && this.rows.kamotsu !== null) {
          const items = this.kamotsuHeaders.map(h => h.value)
          const text = this.searchText
          const length = this.rows.kamotsu.filter(r => {
            for (let i = 0; i < items.length; i++) {
              const hit = this.filtering(r[items[i]], text, r)
              if (hit) { return true }
            }
            return false
          }).length
          return length
        }
      }
      return cnt
    },
    // 照会モード
    isShoukaiMode () {
      return this.modeOfEdit === 1
    },
    // 編集モード
    isEditMode () {
      return this.EditMode
    },
    // 参照モード
    isPrevMode () {
      return !this.EditMode
    },
    // 荷主指定有無
    isNinushiEditMode () {
      if (this.initializeFlg) { return true }
      if (!this.isValueCheck(this.conditions.torihikisakiCd)) { return false }
      if (!this.ninushiEditMode) { return false }
      return true
    },
    // 保存ボタン制御
    isSaveButtonDisabled () {
      return this.rowCountCustom === 0
    },
    // ボタン表示非表示
    isSaveButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1 && this.ninushiShitei && !this.EditMode) {
        return true
      }
      return false
    },
    isEditStartButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1 && this.ninushiShitei && !this.EditMode) {
        return true
      }
      return false
    },
    isEditEndButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1 && this.ninushiShitei && this.EditMode) {
        return true
      }
      return false
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0 || this.isCsvDownloader
    }
  },
  created () {
    this.initialize()
    this.setEnableViewScroll(true)
  },
  mounted () {
  },
  methods: {
    // 初期値クローン
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    beforeRouteLeaveByMenu: function (next) {
      const opt = {
        nextCallback: next
      }
      this.preventTransition(opt)
    },
    filtering (value, search, item) {
      return this.Filters.filter(value, search, item)
    },
    initialize () {
      console.log('initialize')
      const self = this
      const option = {
        loadMasters: ['msystax', 'msteigyosho', 'msttorihikisaki', 'msthacchakuchi', 'vwcmsteigyoshojininlist'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            resolve()
          })
        },
        initializeInputPromise: function () {
          console.log('■initializeInputPromise')
          // 入力内容初期化
          return new Promise((resolve) => {
            self.rows = {}
            var dt = new Date()
            self.conditions.seikyuStartYmdString = self.getDateYmdString(dt, 1)
            self.conditions.seikyuEndYmdString = self.getDateYmdString(dt, 99)
            self.conditions.eigyoshoCd = self.usersEigyoshoCd
            self.initializeFlg = true
            self.headersClear()
            self.dataClear()
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          return new Promise((resolve) => {
            // ユーザ保存項目の復元
            resolve()
          })
        },
        researchPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
            resolve()
          })
        },
        // 権限によるボタン制御
        // 表示モードによるボタン制御
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              this.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              this.modeKengen = 1
            } else {
              // フルアクセス
              this.modeKengen = 2
            }
            // thisId == 0 then 新規モード
            if (this.id === 0) {
              this.modeOfEdit = 0 // 新規モード
            } else if (this.modeKengen === 0) {
              this.modeOfEdit = 1 // 照会モード
            } else {
              this.modeOfEdit = 2 // 更新モード
            }
            resolve()
          })
        },
        settingItemMethod: (kengen) => {
          console.log('settingItemMethod', kengen)
        }

      }
      console.info('call initializeForRegister', this.initializeForRegister, option)
      this.initializeForViewer(option)
    },
    onSearchButtonClick: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/Thbzmd0010/SearchChildren', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          if (data.isValid) {
            self.EditMode = false
            self.rows = data.payload
            self.headersClear()
            if (self.rows !== null) {
              self.funcninushiEditMode()
              self.initializeFlg = false
              // ヘッダ作成
              self.CreateHeader(self.rows)
              // 【貨物】
              self.rows.kamotsu = self.rows.kamotsu.map((kamotsu) => {
                // ユーザー金額をそれぞれ seikyu に統一する
                kamotsu.seikyu1 = kamotsu.userKingakuKazei1ShiyoFlg ? self.getNullValue(kamotsu.userKingakuKazei1) : 0
                kamotsu.seikyu2 = kamotsu.userKingakuKazei2ShiyoFlg ? self.getNullValue(kamotsu.userKingakuKazei2) : 0
                kamotsu.seikyu3 = kamotsu.userKingakuKazei3ShiyoFlg ? self.getNullValue(kamotsu.userKingakuKazei3) : 0
                kamotsu.seikyu4 = kamotsu.userKingakuHikazei1ShiyoFlg ? self.getNullValue(kamotsu.userKingakuHikazei1) : 0
                kamotsu.seikyu5 = kamotsu.userKingakuHikazei2ShiyoFlg ? self.getNullValue(kamotsu.userKingakuHikazei2) : 0
                kamotsu.seikyu6 = kamotsu.userKingakuHikazei3ShiyoFlg ? self.getNullValue(kamotsu.userKingakuHikazei3) : 0
                // エラーフラグ追加
                kamotsu.errFlg = false
                // 各項目フォーマット
                kamotsu = self.kamotsuFormat(kamotsu)

                // 【日報】
                kamotsu.nippo.map((nippo) => {
                  nippo.uriageKingaku = self.dataFormatter(nippo.uriageKingaku, 2)
                  nippo.jissekiSagyoYmd = self.dataFormatter(nippo.jissekiSagyoYmd, 0)
                  return nippo
                })
                return kamotsu
              })
              // 再計算
              self.reCalc()
              self.rows.kamotsu.unshift('dummy')
              self.rows.kamotsu.splice(0, 1)
            } else {
              self.dataClear()
              self.headersClear()
              self.initializeFlg = true
              // self.searchMode = false
            }
          }
          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {
            // ユーザ保存項目 なし
          }
        }
      }
      this.search(opt)
    },
    clear: function () {
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            var dt = new Date()
            this.conditions = {
              seikyuStartYmdString: this.getDateYmdString(dt, 1),
              seikyuEndYmdString: this.getDateYmdString(dt, 99),
              torihikisakiCd: '',
              eigyoshoCd: this.usersEigyoshoCd,
              chakuchiCd: '',
              jomuinCd: '',
              yoshasakiCd: ''
            }
            this.initializeFlg = true
            this.ninushiShitei = false
            this.editButtonDisplay = false
            this.EditMode = false
            this.searchText = ''
            this.dataClear()
            this.headersClear()
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    onCsvButtonClick: function (e) {
      this.isCsvDownloader = true
      this.HttpClient
        .post('/api/v1/Thbzmd0010/CsvDownload', this.conditions)
        .then((data) => {
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('download')
          this.isCsvDownloader = false
          elem.href = window.URL.createObjectURL(blob)
          elem.click()
        })
    },
    // 保存ボタン
    onSaveButtonClick: function (e) {
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.id = data.payload.id
            this.onSearchButtonClick()
            resolve()
          })
        },
        getIdMethod: () => {
          return self.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            // self.id = id
            // self.transition(0, { id: id }, this.initialize)
            this.setEnableViewScroll(true)
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.rows.id }
          }
        },
        isUpdateModeMethod: function () {
          return self.id !== 0
        },
        isNoRefreshModeMethod: function () {
          return true
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      this.register(opt)
    },
    registerPromise: function () {
      const self = this
      var meisaiArr = self.selectedItemKamotsu.filter(kamotsuMeisai => kamotsuMeisai.id !== null)
      var hinmokuArr = self.selectedItemKamotsu.filter(kamotsuHinmoku => kamotsuHinmoku.hinmokuCount === 1)

      var updateList = {}
      updateList.TrNippoKingakuList = this.selectedItemNippo

      // 貨物情報設定（明細に紐づく金額設定）
      meisaiArr.map((kamotsu) => {
        // ID
        kamotsu.id = kamotsu.juchuKingakuId
        // 請求運賃 ⇒ 基本運賃
        if (kamotsu.uchizeiFlg) {
          // 通行料（内税）
          if (kamotsu.tsukoryo === null) {
            kamotsu.hiwayPrice = 0
          } else {
            kamotsu.hiwayPrice = kamotsu.tsukoryo
          }
        } else {
          // 通行料（外税）
          if (kamotsu.tsukoryo === null) {
            kamotsu.userKingakukazei10 = 0
          } else {
            kamotsu.userKingakukazei10 = kamotsu.tsukoryo
          }
        }
        // 請求１～３
        kamotsu.userKingakuKazei1 = kamotsu.seikyu1
        kamotsu.userKingakuKazei2 = kamotsu.seikyu2
        kamotsu.userKingakuKazei3 = kamotsu.seikyu3
        kamotsu.userKingakuHikazei1 = kamotsu.seikyu4
        kamotsu.userKingakuHikazei2 = kamotsu.seikyu5
        kamotsu.userKingakuHikazei3 = kamotsu.seikyu6
        return kamotsu
      })

      // 請求運賃（品目に紐づく金額設定）
      hinmokuArr.forEach(function (elem) {
        if (elem.hinmokuCount === 1) {
          var hinmokuRow = {}
          hinmokuRow.id = elem.hinmokuJuchuKingakuId
          hinmokuRow.kihonUnchin = elem.seikyuUnchin
          hinmokuRow.updDate = elem.hinmokuUpdDate
          meisaiArr.push(hinmokuRow)
        }
      })

      // 日報情報設定
      updateList.TrNippoKingakuList.map((nippo) => {
        // ID
        nippo.id = nippo.sagyoKingakuId
        // 売上金額 ⇒ 売上金額
        nippo.kihonUnchin = nippo.uriageKingaku
        return nippo
      })

      // 最終行に追加
      updateList.TrKamotsuKingakuList = meisaiArr

      // 更新モード固定
      const f = self.HttpClient.post('/api/v1/Thbzmd0010/UpdateMulti?id=1', updateList)
      return f
    },
    validateRows: function (e) {
      return true
    },
    registerValidate: function () {
      var chk = false
      // 保存時エラーチェック
      const listData = this.rows.kamotsu.filter(function (elem) {
        return elem.errFlg === true
      }).map(function (elem) {
        return elem
      })
      if (listData.length === 0) {
        chk = true
      } else {
        this.setInvalidSummaryMessage('COME0021')
      }
      return chk
    },
    // shurui 0:日付 1:時刻 2:数値
    dataFormatter: function (item, shurui) {
      if (item !== null) {
        switch (shurui) {
          case 0:
            // 日付
            return filter.dateFormatter(item)
          case 1:
            // 時刻
            return item.slice(0, 5)
          case 2:
            if (isFinite(item)) {
              // 数値
              return filter.numericFormatter(Number(item))
            } else {
              return item
            }
        }
      }
    },
    // 貨物金額
    kingakuSaveKamotsu: function (e, row) {
      var expandInfo = []
      if (e === true && isFinite(this.getNullValue(row.value))) {
        // 貨物
        row.item = this.kamotsuFormat(row.item)

        const dtArr = this.selectedItemKamotsu.filter(item => item.juchuKingakuId === row.item.juchuKingakuId)
        if (dtArr.length === 0) {
          // 追加
          this.selectedItemKamotsu.push(row.item)
          this.selectedItemKamotsuCheck.push(row.item, true)
          expandInfo.push(row.item, true)
        } else {
          // 更新
          const targetItem = this.selectedItemKamotsu.findIndex((rec) => rec.juchuKingakuId === row.item.juchuKingakuId)
          this.selectedItemKamotsu.splice(targetItem, 1, row.item)
          expandInfo.push(row.item, true)
        }
      } else {
        this.selectedItemKamotsu = this.selectedItemKamotsu.filter(item => item.juchuKingakuId !== row.item.juchuKingakuId)
        expandInfo.push(row.item, true)
      }
      this.kamotsu_expanded = expandInfo
      // 再計算
      // 請求金額
      var seikyuKingaku = 0
      var seikyuUnchin = this.getNullValue(row.item.seikyuUnchin)
      var tsukoryo = this.getNullValue(row.item.zeinukiHidden)
      var seikyu1 = this.getNullValue(row.item.seikyu1)
      var seikyu2 = this.getNullValue(row.item.seikyu2)
      var seikyu3 = this.getNullValue(row.item.seikyu3)
      var seikyu4 = this.getNullValue(row.item.seikyu4)
      var seikyu5 = this.getNullValue(row.item.seikyu5)
      var seikyu6 = this.getNullValue(row.item.seikyu6)
      seikyuKingaku = seikyuUnchin +
                      tsukoryo +
                      seikyu1 +
                      seikyu2 +
                      seikyu3 +
                      seikyu4 +
                      seikyu5 +
                      seikyu6

      // 売上金額
      var nippoExistsFlg = false
      var uriageKingaku = 0
      // 売上金額集計
      this.rows.kamotsu.map((kamotsu) => {
        if (kamotsu.id === row.item.id) {
          kamotsu.nippo.map((nippo) => {
            nippoExistsFlg = true
            uriageKingaku = this.getNullValue(uriageKingaku) + this.getNullValue(nippo.uriageKingaku)
            return uriageKingaku
          })
        }
        return uriageKingaku
      })
      // 日報がいるなら計算する
      if (nippoExistsFlg === true) {
        this.isCalcCheck = this.calcValidateCheck(seikyuKingaku, uriageKingaku)
      }
      // 再計算
      this.reCalc()
      row.item.errFlg = !this.isCalcCheck
    },
    // 作業金額
    kingakuSaveNippo: function (e, row) {
      // 親（受注基本取得）
      var self = this
      self.seikyuKingaku = 0
      const listData = this.rows.kamotsu.filter(function (elem) {
        return elem.id === row.item.trJuchuMeisaiId
      }).map(function (elem) {
        self.seikyuKingaku = self.seikyuKingaku + self.getNullValue(elem.seikyuUnchin)
        // self.seikyuKingaku = self.seikyuKingaku + self.getNullValue(elem.tsukoryo)
        self.seikyuKingaku = self.seikyuKingaku + self.getNullValue(elem.zeinukiHidden)
        self.seikyuKingaku = self.seikyuKingaku + self.getNullValue(elem.seikyu1)
        self.seikyuKingaku = self.seikyuKingaku + self.getNullValue(elem.seikyu2)
        self.seikyuKingaku = self.seikyuKingaku + self.getNullValue(elem.seikyu3)
        self.seikyuKingaku = self.seikyuKingaku + self.getNullValue(elem.seikyu4)
        self.seikyuKingaku = self.seikyuKingaku + self.getNullValue(elem.seikyu5)
        self.seikyuKingaku = self.seikyuKingaku + self.getNullValue(elem.seikyu6)
        return elem
      })

      // 自分（日報）
      if (e === true && isFinite(row.value)) {
        row.item.uriageKingaku = this.dataFormatter(row.item.uriageKingaku, 2)
        // 親（貨物）のチェックON
        const dtArrKamotsu = this.selectedItemKamotsu.filter(item => item.juchuKingakuId === listData[0].juchuKingakuId)
        // 自分（日報）
        const dtArrNippo = this.selectedItemNippo.filter(item => item.sagyoKingakuId === row.item.sagyoKingakuId)
        if (dtArrNippo.length === 0) {
          // 日報追加
          this.selectedItemNippo.push(row.item)
          // 親（貨物）のチェックON
          if (dtArrKamotsu.length === 0) {
            // 追加
            this.selectedItemKamotsuCheck.push(listData[0], true)
          }
        } else {
          // 更新
          const targetItem = this.selectedItemNippo.findIndex((rec) => rec.sagyoKingakuId === row.item.sagyoKingakuId)
          this.selectedItemNippo.splice(targetItem, 1, row.item)
        }
      } else {
        this.selectedItemNippo = this.selectedItemNippo.filter(item => item.sagyoKingakuId !== row.item.sagyoKingakuId)
      }

      // 売上金額
      var uriageKingaku = 0
      // 売上金額集計
      this.rows.kamotsu.map((kamotsu) => {
        if (kamotsu.id === row.item.trJuchuMeisaiId) {
          kamotsu.nippo.map((nippo) => {
            uriageKingaku = this.getNullValue(uriageKingaku) + this.getNullValue(nippo.uriageKingaku)
            return uriageKingaku
          })
        }
        return uriageKingaku
      })

      this.isCalcCheck = this.calcValidateCheck(this.seikyuKingaku, uriageKingaku)
      // 再計算
      this.reCalc()

      listData[0].errFlg = !this.isCalcCheck
    },
    // チェック：強制OFF
    itemSelectKamotsu: function (e) {
      this.selectedItemKamotsuCheck.push(e, false)
    },
    itemSelectNippo: function (e) {
      this.selectedItemNippoCheck.push(e, false)
    },
    // 使用フラグ可否による列表示制御
    funcAlign: function (bool) {
      return bool ? 'right' : ' d-none'
    },
    // 明細ヘッダ作成
    CreateHeader (rows) {
      // 貨物
      this.kamotsuHeaders = [
        { text: '売上展開', value: 'data-table-expand', width: '5vh', sortable: false },
        { text: '荷主ID', value: 'ninushiId', align: ' d-none' },
        { text: '荷主', value: 'ninushiNm', width: '5vh' },
        { text: '着地', value: 'chakuchiNm', width: '5vh' },
        { text: '営業所CD', value: 'eigyoshoCd', align: ' d-none' },
        { text: '受注営業所', value: 'eigyoshoNm', width: '10vh' },
        { text: '請求計上日', value: 'seikyuYoteiYmd', width: '10vh' },
        { text: '貨物No', value: 'kamotsuNo', width: '10vh' },
        { text: '請求運賃', value: 'seikyuUnchin', width: '10vh', align: 'right' },
        { text: '通行料', value: 'tsukoryo', width: '10vh', align: 'right' },
        { text: '税抜き額', value: 'zeinuki', width: '10vh', align: 'right' }
      ]
      // 荷主指定あり
      if (this.isValueCheck(this.conditions.torihikisakiCd)) {
        this.setSeikyuShiyoFlg(false)
        this.editButtonDisplay = true
        // 請求項目１～３ 使用フラグ可否
        this.seikyu1ShiyoFlg = rows.kamotsu[0].userKingakuKazei1ShiyoFlg
        this.seikyu2ShiyoFlg = rows.kamotsu[0].userKingakuKazei2ShiyoFlg
        this.seikyu3ShiyoFlg = rows.kamotsu[0].userKingakuKazei3ShiyoFlg
        this.seikyu4ShiyoFlg = rows.kamotsu[0].userKingakuHikazei1ShiyoFlg
        this.seikyu5ShiyoFlg = rows.kamotsu[0].userKingakuHikazei2ShiyoFlg
        this.seikyu6ShiyoFlg = rows.kamotsu[0].userKingakuHikazei3ShiyoFlg
        // 請求項目１～３ タイトル設定
        this.seikyu1Nm = rows.kamotsu[0].userKingakuKazei1Title
        this.seikyu2Nm = rows.kamotsu[0].userKingakuKazei2Title
        this.seikyu3Nm = rows.kamotsu[0].userKingakuKazei3Title
        this.seikyu4Nm = rows.kamotsu[0].userKingakuHikazei1Title
        this.seikyu5Nm = rows.kamotsu[0].userKingakuHikazei2Title
        this.seikyu6Nm = rows.kamotsu[0].userKingakuHikazei3Title

        // 請求項目１～３ ヘッダ列生成
        this.kamotsuHeaders.push({ text: this.seikyu1Nm, value: 'seikyu1', width: '10vh', align: this.funcAlign(this.seikyu1ShiyoFlg) })
        this.kamotsuHeaders.push({ text: this.seikyu2Nm, value: 'seikyu2', width: '10vh', align: this.funcAlign(this.seikyu2ShiyoFlg) })
        this.kamotsuHeaders.push({ text: this.seikyu3Nm, value: 'seikyu3', width: '10vh', align: this.funcAlign(this.seikyu3ShiyoFlg) })
        this.kamotsuHeaders.push({ text: this.seikyu4Nm, value: 'seikyu4', width: '10vh', align: this.funcAlign(this.seikyu4ShiyoFlg) })
        this.kamotsuHeaders.push({ text: this.seikyu5Nm, value: 'seikyu5', width: '10vh', align: this.funcAlign(this.seikyu5ShiyoFlg) })
        this.kamotsuHeaders.push({ text: this.seikyu6Nm, value: 'seikyu6', width: '10vh', align: this.funcAlign(this.seikyu6ShiyoFlg) })

        this.isShiyoFlgDummyCount()
      } else {
        // 荷主指定なし
        this.editButtonDisplay = false
        this.setSeikyuShiyoFlg(true)

        this.seikyu1Nm = DEFAULT_HEADER_NAME1
        this.seikyu2Nm = DEFAULT_HEADER_NAME2
        this.seikyu3Nm = DEFAULT_HEADER_NAME3
        this.seikyu4Nm = DEFAULT_HEADER_NAME4
        this.seikyu5Nm = DEFAULT_HEADER_NAME5
        this.seikyu6Nm = DEFAULT_HEADER_NAME6

        this.kamotsuHeaders.push({ text: this.seikyu1Nm, value: 'seikyu1', width: '10vh', align: this.funcAlign(this.seikyu1ShiyoFlg) })
        this.kamotsuHeaders.push({ text: this.seikyu2Nm, value: 'seikyu2', width: '10vh', align: this.funcAlign(this.seikyu2ShiyoFlg) })
        this.kamotsuHeaders.push({ text: this.seikyu3Nm, value: 'seikyu3', width: '10vh', align: this.funcAlign(this.seikyu3ShiyoFlg) })
        this.kamotsuHeaders.push({ text: this.seikyu4Nm, value: 'seikyu4', width: '10vh', align: this.funcAlign(this.seikyu4ShiyoFlg) })
        this.kamotsuHeaders.push({ text: this.seikyu5Nm, value: 'seikyu5', width: '10vh', align: this.funcAlign(this.seikyu5ShiyoFlg) })
        this.kamotsuHeaders.push({ text: this.seikyu6Nm, value: 'seikyu6', width: '10vh', align: this.funcAlign(this.seikyu6ShiyoFlg) })
        this.isShiyoFlgDummyCount()
      }

      // 日報
      this.nippoHeaders = [
        { text: '貨物No', value: 'kamotsuNo', align: ' d-none' },
        { text: '営業所コード', value: 'eigyoshoId', align: ' d-none' },
        { text: '売上営業所', value: 'eigyoshoNm', width: '9vh' },
        { text: '日報日', value: 'jissekiSagyoYmd', width: '10vh' },
        { text: '日報No', value: 'sagyoJissekiNo', width: '10vh' },
        { text: '売上金額', value: 'uriageKingaku', width: '10vh', align: 'right' },
        { text: '乗務員', value: 'jininNmSei', width: '27vh' },
        { text: '傭車先', value: 'yoshasakiNm', width: '27vh' }
      ]
    },
    onEditButtonClick: function (e) {
      this.EditMode = true
    },
    onPrevButtonClick: function (e) {
      this.EditMode = false
    },
    searchValidate: function () {
      var msg = validators.compareDate(this.conditions.seikyuStartYmdString, this.conditions.seikyuEndYmdString)
      if (msg !== undefined) {
        this.$refs.seikyuStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.$refs.seikyuEndString[this.Ctrls.SET_INVALID_METHOD](msg)
        return false
      }
      msg = validators.compareDate(this.conditions.seikyuStartYmdString, this.conditions.seikyuEndYmdString)
      if (msg !== undefined) {
        this.$refs.seikyuStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.$refs.seikyuEndString[this.Ctrls.SET_INVALID_METHOD](msg)
        return false
      }
      return true
    },
    // datatable関連クリア
    dataClear: function () {
      this.rows = []
      this.summarySeikyuUnchin = 0
      this.summaryTsukoryo = 0
      this.summaryZeinuki = 0
      this.summarySeikyu1 = 0
      this.summarySeikyu2 = 0
      this.summarySeikyu3 = 0
      this.summarySeikyu4 = 0
      this.summarySeikyu5 = 0
      this.summarySeikyu6 = 0
      this.summaryUriageKingaku = 0
      this.summaryAll = 0
    },
    headersClear: function () {
      this.kamotsuHeaders = []
      this.nippoHeaders = []
      this.selectedItemKamotsu = []
      this.selectedItemNippo = []
      this.selectedItemKamotsuCheck = []
      this.kamotsu_expanded = []
    },
    calcValidateCheck: function (seikyuKingaku, uriageKingaku) {
      if (seikyuKingaku === uriageKingaku) {
        return true
      }
      return false
    },
    // 全部再計算
    reCalc: function () {
      // 請求運賃
      this.calcSummarySeikyuUnchin()
      // 通行料(税抜)
      this.calcSummaryTsukoryo()
      // 請求項目１
      this.calcSummarySeikyu1()
      // 請求項目２
      this.calcSummarySeikyu2()
      // 請求項目３
      this.calcSummarySeikyu3()
      // 請求項目４
      this.calcSummarySeikyu4()
      // 請求項目５
      this.calcSummarySeikyu5()
      // 請求項目６
      this.calcSummarySeikyu6()
      // 合計
      this.calcSummaryAll()
      // 売上金額
      this.calcSummaryUriageKingaku()
    },
    // 請求運賃計
    calcSummarySeikyuUnchin: function (item) {
      var seikyuUnchinSummary = 0
      this.rows.kamotsu.map((kamotsu) => {
        seikyuUnchinSummary = this.getNullValue(seikyuUnchinSummary) + this.getNullValue(kamotsu.seikyuUnchin)
        return seikyuUnchinSummary
      })
      this.summarySeikyuUnchin = seikyuUnchinSummary
    },
    // 通行料計
    calcSummaryTsukoryo: function (item) {
      var tsukoryoSummary = 0
      this.rows.kamotsu.map((kamotsu) => {
        // tsukoryoSummary = this.getNullValue(tsukoryoSummary) + this.getNullValue(kamotsu.tsukoryo)
        tsukoryoSummary = this.getNullValue(tsukoryoSummary) + this.getNullValue(kamotsu.zeinukiHidden)
        return tsukoryoSummary
      })
      this.summaryTsukoryo = tsukoryoSummary
    },
    // 請求項目１計
    calcSummarySeikyu1: function (item) {
      var seikyu1Summary = 0
      this.rows.kamotsu.map((kamotsu) => {
        seikyu1Summary = this.getNullValue(seikyu1Summary) + this.getNullValue(kamotsu.seikyu1)
        return seikyu1Summary
      })
      this.summarySeikyu1 = seikyu1Summary
    },
    // 請求項目２計
    calcSummarySeikyu2: function (item) {
      var seikyu2Summary = 0
      this.rows.kamotsu.map((kamotsu) => {
        seikyu2Summary = this.getNullValue(seikyu2Summary) + this.getNullValue(kamotsu.seikyu2)
        return seikyu2Summary
      })
      this.summarySeikyu2 = seikyu2Summary
    },
    // 請求項目３計
    calcSummarySeikyu3: function (item) {
      var seikyu3Summary = 0
      this.rows.kamotsu.map((kamotsu) => {
        seikyu3Summary = this.getNullValue(seikyu3Summary) + this.getNullValue(kamotsu.seikyu3)
        return seikyu3Summary
      })
      this.summarySeikyu3 = seikyu3Summary
    },
    // 請求項目４計
    calcSummarySeikyu4: function (item) {
      var seikyu4Summary = 0
      this.rows.kamotsu.map((kamotsu) => {
        seikyu4Summary = this.getNullValue(seikyu4Summary) + this.getNullValue(kamotsu.seikyu4)
        return seikyu4Summary
      })
      this.summarySeikyu4 = seikyu4Summary
    },
    // 請求項目５計
    calcSummarySeikyu5: function (item) {
      var seikyu5Summary = 0
      this.rows.kamotsu.map((kamotsu) => {
        seikyu5Summary = this.getNullValue(seikyu5Summary) + this.getNullValue(kamotsu.seikyu5)
        return seikyu5Summary
      })
      this.summarySeikyu5 = seikyu5Summary
    },
    // 請求項目６計
    calcSummarySeikyu6: function (item) {
      var seikyu6Summary = 0
      this.rows.kamotsu.map((kamotsu) => {
        seikyu6Summary = this.getNullValue(seikyu6Summary) + this.getNullValue(kamotsu.seikyu6)
        return seikyu6Summary
      })
      this.summarySeikyu6 = seikyu6Summary
    },
    // 合計
    calcSummaryAll: function (item) {
      this.summaryAll = this.getNullValue(this.summarySeikyuUnchin) +
      this.getNullValue(this.summaryTsukoryo) +
      this.getNullValue(this.summarySeikyu1) +
      this.getNullValue(this.summarySeikyu2) +
      this.getNullValue(this.summarySeikyu3) +
      this.getNullValue(this.summarySeikyu4) +
      this.getNullValue(this.summarySeikyu5) +
      this.getNullValue(this.summarySeikyu6)
    },
    // 売上金額合計
    calcSummaryUriageKingaku: function (item) {
      // 売上金額集計
      var uriageKingakuSummary = 0
      this.rows.kamotsu.map((kamotsu) => {
        kamotsu.nippo.map((nippo) => {
          uriageKingakuSummary = this.getNullValue(uriageKingakuSummary) + this.getNullValue(nippo.uriageKingaku)
          return uriageKingakuSummary
        })
        return uriageKingakuSummary
      })
      this.summaryUriageKingaku = uriageKingakuSummary
    },
    // shubetsu 1:月初 99:月末
    getDateYmdString: function (dt, shubetsu) {
      var result
      if (shubetsu === 1) {
        // 月初
        result = new Date(dt.getFullYear(), dt.getMonth(), 1)
      } else {
        // 月末
        result = new Date(dt.getFullYear(), dt.getMonth() + 1, 0)
      }
      return filter.dateFormatter(result)
    },
    isSeikyuKomokuSummaryNm1: function () { return this.seikyu1Nm + '計' },
    isSeikyuKomokuSummaryNm2: function () { return this.seikyu2Nm + '計' },
    isSeikyuKomokuSummaryNm3: function () { return this.seikyu3Nm + '計' },
    isSeikyuKomokuSummaryNm4: function () { return this.seikyu4Nm + '計' },
    isSeikyuKomokuSummaryNm5: function () { return this.seikyu5Nm + '計' },
    isSeikyuKomokuSummaryNm6: function () { return this.seikyu6Nm + '計' },
    // Nullをゼロに変換(カンマ除去も)
    getNullValue (inputValue) {
      if (inputValue === null) { return 0 }
      if (inputValue === undefined) { return 0 }
      if (inputValue === '') { return 0 }
      return this.getSanitizedValue(inputValue)
    },
    // 貨物関連フォーマット
    kamotsuFormat (kamotsu) {
      var taxKijunDate = this.dataFormatter(kamotsu.seikyuYoteiYmd, 0)

      kamotsu.seikyuYoteiYmd = this.dataFormatter(kamotsu.seikyuYoteiYmd, 0)
      kamotsu.seikyuUnchin = this.dataFormatter(this.getNullValue(kamotsu.seikyuUnchin), 2)
      kamotsu.tsukoryo = this.dataFormatter(this.getNullValue(kamotsu.tsukoryo), 2)
      if (kamotsu.uchizeiFlg) {
        kamotsu.zeinuki = this.dataFormatter(tax.calcWithoutTax5u6d(this.getNullValue(kamotsu.tsukoryo), taxKijunDate), 2)
        kamotsu.zeinukiHidden = this.dataFormatter(tax.calcWithoutTax5u6d(this.getNullValue(kamotsu.tsukoryo), taxKijunDate), 2)
      } else {
        kamotsu.zeinukiHidden = this.dataFormatter(this.getNullValue(kamotsu.tsukoryo), 2)
      }
      kamotsu.seikyu1 = this.dataFormatter(this.getNullValue(kamotsu.seikyu1), 2)
      kamotsu.seikyu2 = this.dataFormatter(this.getNullValue(kamotsu.seikyu2), 2)
      kamotsu.seikyu3 = this.dataFormatter(this.getNullValue(kamotsu.seikyu3), 2)
      kamotsu.seikyu4 = this.dataFormatter(this.getNullValue(kamotsu.seikyu4), 2)
      kamotsu.seikyu5 = this.dataFormatter(this.getNullValue(kamotsu.seikyu5), 2)
      kamotsu.seikyu6 = this.dataFormatter(this.getNullValue(kamotsu.seikyu6), 2)
      return kamotsu
    },
    // 色かえる
    itemRowBackground (item) {
      return item.errFlg ? 'cellBackgroundColorRed' : 'cellBackgroundColorWhite'
    },
    isValueCheck (item) {
      if (item === undefined) { return false }
      if (item === '') { return false }
      if (item === null) { return false }
      return true
    },
    // 荷主指定有無
    funcninushiEditMode () {
      if (!this.isValueCheck(this.conditions.torihikisakiCd)) {
        this.ninushiEditMode = false
        this.ninushiShitei = false
      } else {
        this.ninushiShitei = true
        this.ninushiEditMode = true
      }
    },
    // 1～6:請求項目１～６
    isNinushiSeikyuShiyoFlg (item) {
      switch (item) {
        case 1: return this.seikyu1ShiyoFlg
        case 2: return this.seikyu2ShiyoFlg
        case 3: return this.seikyu3ShiyoFlg
        case 4: return this.seikyu4ShiyoFlg
        case 5: return this.seikyu5ShiyoFlg
        case 6: return this.seikyu6ShiyoFlg
      }
    },
    // 品目カウンタ（複数件ある場合は基本運賃編集不可）
    isHinmokuCount (row) {
      if (row.hinmokuCount === 1) {
        return true
      }
      return false
    },
    // フッタ部コントロール表示非表示制御
    isShiyoFlgDummyCount () {
      this.shiyoFlgCount = 0
      if (this.seikyu1ShiyoFlg) { this.shiyoFlgCount += 1 }
      if (this.seikyu2ShiyoFlg) { this.shiyoFlgCount += 1 }
      if (this.seikyu3ShiyoFlg) { this.shiyoFlgCount += 1 }
      if (this.seikyu4ShiyoFlg) { this.shiyoFlgCount += 1 }
      if (this.seikyu5ShiyoFlg) { this.shiyoFlgCount += 1 }
      if (this.seikyu6ShiyoFlg) { this.shiyoFlgCount += 1 }
    },
    // 使用フラグ一括初期化
    setSeikyuShiyoFlg (bool) {
      this.seikyu1ShiyoFlg = bool
      this.seikyu2ShiyoFlg = bool
      this.seikyu3ShiyoFlg = bool
      this.seikyu4ShiyoFlg = bool
      this.seikyu5ShiyoFlg = bool
      this.seikyu6ShiyoFlg = bool
    },
    // カンマ除去
    getSanitizedValue (inputVal) {
      if (typeof inputVal === 'string' && inputVal !== '') {
        var retVal = inputVal.replaceAll(',', '')
        if (isFinite(retVal)) {
          return parseFloat(retVal)
        } else {
          return ''
        }
      }
      return inputVal
    }
  }
}
